import { AxiosError } from 'axios';

export const getRequestUrl = (error: AxiosError): string | undefined => {
  const request = error.request as { url?: string } | undefined;

  return request?.url ?? error.config?.url;
};
